import * as i from 'types';
import * as React from 'react';
import Select, { StylesConfig, Props as SelectProps, GroupBase } from 'react-select';
import { useTheme } from 'styled-components';

import { FormField } from '../FormField';
import customStyles from './customStyles';

export const SelectPure = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  additionalStyles, name, label, error, direction = 'vertical', description,
  ...otherProps
}: SelectPureProps<Option, IsMulti, Group>) => {
  const theme = useTheme();

  const formFieldProps = { name, label, error, direction, description };
  const selectProps = { ...otherProps };
  const stylingProps = {
    styles: {
      ...customStyles<Option, IsMulti, Group>(theme),
      ...additionalStyles,
    },
  };

  return (
    <FormField {...formFieldProps}>
      <Select
        name={name}
        {...selectProps}
        {...stylingProps}
      />
    </FormField>
  );
};

type SelectPureProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> =
  SelectProps<Option, IsMulti, Group> &
  i.FormFieldProps & {
    additionalStyles?: StylesConfig<Option, IsMulti, Group>;
  };

